import { render } from "./news_card.vue?vue&type=template&id=3d5872aa"
import script from "./news_card.vue?vue&type=script&lang=js"
export * from "./news_card.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/news_card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d5872aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d5872aa', __exports__)) {
    api.reload('3d5872aa', __exports__)
  }
  
  module.hot.accept("./news_card.vue?vue&type=template&id=3d5872aa", () => {
    api.rerender('3d5872aa', render)
  })

}


export default __exports__